import PropTypes from "prop-types"

export const feedFilterPropType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  getLabel: PropTypes.func.isRequired,
  filter: PropTypes.func.isRequired
})
